var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcticonsCreatorStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arcticons:creator-studio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.24137 3.4375L10.5009 6.95563L8.24137 10.4731M14.1219 3.4375L16.382 6.95563L14.1219 10.4731M20.0024 3.4375L22.2625 6.95563L20.0024 10.4731M3.61816 10.4731H26.4102M18.413 17.655L13.8656 14.9913C13.7466 14.9214 13.6117 14.8846 13.4742 14.8845C13.3368 14.8845 13.2018 14.9211 13.0828 14.9908C12.9637 15.0605 12.8649 15.1608 12.7962 15.2816C12.7275 15.4023 12.6914 15.5393 12.6915 15.6788V21.0063C12.6914 21.1457 12.7275 21.2827 12.7962 21.4034C12.8649 21.5242 12.9637 21.6245 13.0828 21.6942C13.2018 21.7639 13.3368 21.8005 13.4742 21.8005C13.6117 21.8004 13.7466 21.7636 13.8656 21.6938L18.413 19.03C18.532 18.9603 18.6308 18.8601 18.6995 18.7395C18.7682 18.6188 18.8044 18.4819 18.8044 18.3425C18.8044 18.2031 18.7682 18.0662 18.6995 17.9455C18.6308 17.8249 18.532 17.7247 18.413 17.655Z",
    stroke: "#100C41",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.1787 3.4375H4.8502C4.52344 3.4375 4.21007 3.5692 3.97902 3.80362C3.74797 4.03804 3.61816 4.35598 3.61816 4.6875V25.3125C3.61816 25.644 3.74797 25.962 3.97902 26.1964C4.21007 26.4308 4.52344 26.5625 4.8502 26.5625H25.1787C25.5055 26.5625 25.8189 26.4308 26.0499 26.1964C26.281 25.962 26.4108 25.644 26.4108 25.3125V4.6875C26.4108 4.35598 26.281 4.03804 26.0499 3.80362C25.8189 3.5692 25.5055 3.4375 25.1787 3.4375Z",
    stroke: "#100C41",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticonsCreatorStudio);
export default __webpack_public_path__ + "static/media/arcticons_creator-studio.e0f93f79d3a51f23c839d7abbfedea32.svg";
export { ForwardRef as ReactComponent };